import { Button, Card, message, Result, Space, Table } from 'antd';
import React, { useContext, useEffect, useState } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useHistory } from 'react-router-dom';
import { Title } from '../../components';
import ContactForm from '../../components/ContactForm';
import LogosAseguradoraProductos from '../../components/LogosAseguradorasProducto';
import LogosEmpresaAseguradora from '../../components/LogosEmpresaAseguradora';
import MonedaSelector from '../../components/MonedaSelector';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import { USER_STATES } from '../../constants';
import EmpresaContext from '../../context/empresa-context';
import UserContext from '../../context/user-context';
import WhatsAppContext from '../../context/whatsapp-context';
import { errorHandler, formatCelular } from '../../utils';
import { instanceRef } from '../../utils/axios';
import { formatoMonedaGenerico } from '../../utils/converters';

const columns = [
  {
    title: 'Detalle de Cobertura',
    dataIndex: 'detalle',
    key: 'detalle'
  },
  {
    title: 'Sumas Aseguradas',
    dataIndex: 'sumas',
    key: 'sumas',
    align: 'right',
    render: (item) => <strong style={{ whiteSpace: 'nowrap' }}>{item}</strong>
  }
];

const CotizacionPersonalForm = (props) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [solicitado, setSolicitado] = useState(false);
  const [loading, setLoading] = useState(false);
  const { user, userState } = useContext(UserContext);
  const { producto, productos, getProductoActual, empresa } = useContext(
    EmpresaContext
  );
  const { actualizarTexto } = useContext(WhatsAppContext);
  const [titulo, setTitulo] = useState('');
  const [token, setToken] = useState();
  const [data, setData] = useState([]);
  const [correo, setCorreo] = useState();
  const [monedas, setMonedas] = useState();
  const [moneda, setMoneda] = useState();
  const [coberturasItems, setCoberturaItems] = useState();
  const history = useHistory();

  const actualizarTextoWhatsApp = (values) => {
    const { nombres, celular } = values;
    actualizarTexto(
      `Nombre: ${nombres || ''}. \nContacto: ${celular || ''}. \n`
    );
  };

  const solicitar = async ({
    nombres,
    celular,
    vendedor,
    correoVendedor,
    celularVendedor,
    correo: correoParam
  }) => {
    try {
      setLoading(true);
      const reCaptchaToken = await executeRecaptcha('cotizacion/enviar');
      const dataEnviar = {
        reCaptchaToken,
        persona: {
          nombres,
          celular: `+595${formatCelular(celular)}`,
          correo: correoParam
        },
        vendedor,
        correoVendedor,
        celularVendedor: celularVendedor
          ? `+595${formatCelular(celularVendedor)}`
          : undefined,
        idProducto: producto,
        tipo_venta: 'estandar'
      };
      const response = await instanceRef.instance.post(
        `cotizacion/enviar`,
        dataEnviar
      );
      setToken(response.data.data);
      setSolicitado(true);
      setCorreo(correoParam);
    } catch (error) {
      message.error('Error al enviar la solicitud');
    }
    setLoading(false);
  };

  const getMonto = (monto) => {
    switch (Number(monto)) {
      case 0:
        return 'Incluye';
      case -1:
        return 'Excluye';
      default:
        return `${formatoMonedaGenerico(moneda, monto)}`;
    }
  };

  const handleOpenUrl = (url) => {
    history.push(url);
  };

  useEffect(() => {
    const getResumen = async () => {
      if (producto && productos.length > 0) {
        setTitulo(getProductoActual().descripcion || '');
        const coberturaItems = await instanceRef.instance.get(
          '/parametros/resumen',
          {
            params: { id_producto: producto }
          }
        );
        const monedasConfiguradas = {};
        coberturaItems.data.data.forEach((item) => {
          monedasConfiguradas[item.moneda.codigo] = item.moneda;
        });

        const monedaGuaranies = Object.values(monedasConfiguradas).find(
          (item) => item.codigo === 'gs'
        );
        if (monedaGuaranies) {
          setMoneda(monedaGuaranies);
        } else {
          const codigoPrimeraMoneda = Object.keys(monedasConfiguradas)[0];
          setMoneda(monedasConfiguradas[codigoPrimeraMoneda]);
        }

        setMonedas(Object.values(monedasConfiguradas));
        setCoberturaItems(coberturaItems.data.data);
      }
    };
    try {
      getResumen();
    } catch (error) {
      errorHandler(error, 'Error al obtener los datos');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [producto, productos, getProductoActual]);

  useEffect(() => {
    if (coberturasItems && moneda) {
      const detail = coberturasItems
        .filter((item) => {
          return item.moneda.codigo === moneda.codigo;
        })
        .map((item) => {
          const row = {
            key: item.id,
            detalle: (
              <div
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: `${item.coberturaItem.descripcion}`
                }}
              />
            ),
            sumas: getMonto(item.monto)
          };
          return row;
        });
      if (detail) {
        setData(detail);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [coberturasItems, moneda]);

  return (
    <>
      <LogosEmpresaAseguradora />
      {productos && productos.length > 0 && (
        <>
          <ResponsiveContainer>
            <Card
              style={{
                margin: '0 auto',
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <>
                {!solicitado && (
                  <>
                    <Space size="large" direction="vertical">
                      <Title>¡Cotizá tu seguro de {titulo}!</Title>
                      {data && data.length > 0 && (
                        <Table
                          fixed
                          scroll={false}
                          bordered
                          columns={columns}
                          dataSource={data}
                          pagination={false}
                        />
                      )}
                      {monedas && monedas.length > 0 && (
                        <MonedaSelector
                          value={moneda.codigo}
                          monedas={monedas}
                          onChange={(e) => {
                            const selected = monedas.filter(
                              (item) => item.codigo === e.target.value
                            )[0];
                            setMoneda(selected);
                          }}
                        />
                      )}
                    </Space>

                    <br />
                    <br />
                    <ContactForm
                      onFinish={(values) => solicitar(values)}
                      solicitado={solicitado}
                      loading={loading}
                      onClick={() => props.history.go(0)}
                      onValuesChange={(_, values) => {
                        actualizarTextoWhatsApp(values);
                        // getClientedata(values);
                      }}
                      empresaTieneSms={empresa.tiene_sms}
                    />
                    <LogosAseguradoraProductos />
                  </>
                )}
              </>
              {solicitado && (
                <Result
                  status="success"
                  title="¡La cotización ha sido enviada!"
                  subTitle={
                    correo
                      ? 'Recibirá un e-mail y SMS para continuar con su solicitud'
                      : 'Recibirá un mensaje de texto para continuar con su solicitud'
                  }
                  extra={
                    user &&
                    (userState === USER_STATES.loggingEnd ||
                      userState === USER_STATES.notLogged) && [
                      <Button
                        type="primary"
                        key="console"
                        onClick={() => handleOpenUrl(`/solicitar/${token}`)}
                      >
                        Continuar con Solicitud
                      </Button>
                    ]
                  }
                />
              )}
            </Card>
            <br />
          </ResponsiveContainer>
        </>
      )}
    </>
  );
};

export default CotizacionPersonalForm;
